<template>
   <div class="toolbar-inner bottomToolbarInner">
    <a v-for="item in bottomItemsData"
       :href="getLink(item.link, item.active)"
       class="toolbarBlock"
       :class="{common_toolbar : item.isSelected}"
       :style="backGroundClicked(item, item.active)"
       :id="item.id"
       @click="printBackground(item.link, item.active)"
      >
      <div class="toolbarBlockIconContainer">
        <i class="icon toolbarBlockIcon"
           :class="isWhite(item)">
        </i>
      </div>
      <div class="toolbarBlockLabel"
           :class="{label_toolbar_selected : item.isSelected, label_toolbar : !item.isSelected}"
           :id="item.idLabel">
           {{ $t(item.label) }}
      </div>
    </a>
   </div>
</template>

<script>
import conf from "@/config/config.dev";

/** TLV 11/03/2020
* @brief Component qui gère les items affichés sur la barre du footer, quand ils sont indiqués dans la
*          propriété bottomItemsData, et dont les couleurs de fond dépendent du
*          service (d'où l'importance de la propriété serviceId)
* @fn La fonction printBackground() va mettre à jour le footer pour indiquer l'item actuellement sélectionné
* @fn La fonction isWhite() va mettre l'item en blanc s'il s'agit de l'item sélectionné en ce moment
*/
import designToolBox from '@/design/designToolBox.json'
import designDealprudence from '@/design/designDealprudence.json'

const flagTOOLBOX = conf.visual === 'TOOLBOX'

const design = flagTOOLBOX ? designToolBox : designDealprudence

export default {
  props: ['serviceId', 'bottomItemsData'],
  data: () => {
    return {
      design: design.menu
    }
  },
  methods: {
    printBackground (data, active) {
      if (active === '1') {
        if (typeof data !== 'string') {
          this.$bus.emit('nextLink', data[this.$engine.user.currentService.id])
        } else {
          this.$bus.emit('nextLink', data)
        }
      }
    },
    isWhite (item) {
      if (this.design.headbandTextColor.length >= 7) {
        var c = this.design.headbandTextColor.substring(1)
        var rgb = parseInt(c, 16)
        var r = (rgb >> 16) & 0xff
        var g = (rgb >> 8) & 0xff
        var b = (rgb >> 0) & 0xff

        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

        if (luma < 40) {
          if (item.isSelected) {
            return item.icon
          } else {
            return item.iconwhite
          }
        } else {
          if (item.isSelected) {
            return item.iconwhite
          } else {
            return item.icon
          }
        }
      }
      if (item.isSelected) {
        return item.iconwhite
      }
      return item.icon
    },
    /* TLV 09/03/2020
    * @brief Méthode qui va déterminer la couleur de fond
    *   de la pastille lorsque l'utilisateur clique sur un item du footer
    * La couleur est prélevée dans le fichier .json correspondant si elle y est indiquée, sinon c'est
    * la couleur du service comme précisé dans le json defaultBackgroundcolorMatchings défini ci-dessous
    */
    backGroundClicked (item, active) {
      if (active === '1') {
        if (item.isSelected) {
          let selectedBackGroundColor = {}
          // if (item.backGroundColor) {
          //   selectedBackGroundColor['backgroundColor'] = item.backGroundColor[this.$engine.user.currentService.id]
          // } else {
          //   let defaultBackgroundcolorMatchings = {
          //     '6': '#FFF',
          //     '1': '#FFF',
          //     '2': '#FFF'
          //   }
          //   selectedBackGroundColor['backgroundColor'] = defaultBackgroundcolorMatchings[this.$engine.user.currentService.id]
          // }
          selectedBackGroundColor['backgroundColor'] = 'var(--headbandColorHover2)'
          return selectedBackGroundColor
        }
        return ''
      }
      return {cursor: 'default'}
    },
    /* Si le link est un json, on retourne le lien associé au service. Sinon, on retourne juste la string */
    getLink (linkItem, active) {
      if (active === '1') {
        if (typeof linkItem !== 'string') {
          return linkItem[this.$engine.user.currentService.id]
        }
        return linkItem
      }
      return ''
    }
  }
}
</script>
